import * as Yup from "yup";
import { WITH_ESTIMATE_TIMELINE } from "./constants";

export const checkListSchema = (
  repairIsHappening?: boolean,
  partItemIds?: string[],
  validServiceItemIds?: string[],
  isWarrantyCheck?: boolean
) =>
  Yup.object().shape({
    needOutstandingRepair: repairIsHappening ? Yup.boolean().required("required") : Yup.boolean().optional(),
    finalRecomendation: Yup.string().when("needOutstandingRepair", {
      is: (needOutstandingRepair) => needOutstandingRepair && !repairIsHappening,
      then: Yup.string().required("Required"),
      otherwise: Yup.string().nullable().optional(),
    }),
    recommendedServices: Yup.array(Yup.string()).nullable().optional(),
    notes: Yup.string().nullable().optional(),
    estimatedTimeline: Yup.date().when("finalRecomendation", {
      is: (finalRecomendation) => WITH_ESTIMATE_TIMELINE.includes(finalRecomendation),
      then: Yup.date().required("Required"),
      otherwise: Yup.date().nullable().optional(),
    }),
    usedOriginalParts: Yup.mixed().required("Required"),
    usedOriginalPartsNotes: Yup.string().when("usedOriginalParts", {
      is: false,
      then: Yup.string().required("Please describe the different parts used"),
      otherwise: Yup.string().nullable().optional(),
    }),
    partItems:
      partItemIds && partItemIds.length > 0 && isWarrantyCheck
        ? Yup.object().shape(
            partItemIds.reduce((acc, itemId) => {
              acc[itemId] = Yup.object()
                .shape({
                  warranty_replacement_reason: Yup.string().required("Warranty replacement reason is required"),
                  warranty_replacement_upgrade: Yup.boolean(),
                })
                .test("valid-item-id", "Item ID must match a service item", function (value) {
                  if (!validServiceItemIds || validServiceItemIds.length === 0) return true;
                  return validServiceItemIds.includes(itemId);
                });
              return acc;
            }, {} as Record<string, any>)
          )
        : Yup.object().optional(),
  });
